import './Download.css';
import '../../index.css';
import React from 'react';

function Download() {
  return (
    <div className="section">
      <h1 className="header">Login To See Your Inventory</h1>
      <h2 className="second-header">Need an Account?</h2>
      <a href="https://play.google.com/store/apps/details?id=com.talofagames.abra" target="_blank" rel="noreferrer">
        <img className="store-img" src="./googlePlay.png" />
      </a>
      <a href="https://apps.apple.com/us/app/run-legends/id1585730648" target="_blank" rel="noreferrer">
        <img className="store-img" src="./appStore.png" />
      </a>
    </div>
  );
}

export default Download;
